"use client";

import { openCookieSettings } from "@/lib/consent";
import { cn } from "@/lib/utils";

export function CookieSettingsButton({ className }: { className?: string }) {
  return (
    <button
      type="button"
      onClick={openCookieSettings}
      className={cn(
        "text-muted-foreground transition-colors hover:text-foreground",
        className,
      )}
    >
      Cookie settings
    </button>
  );
}
